import { oz } from '@weft/utils';

export const CRITERION_OPERATORS = Object.freeze({
  Equals: 'Equals',
  DoesntEqual: 'DoesntEqual',
  Has: 'Has',
  In: 'In',
  Contains: 'Contains',
  DoesntContain: 'DoesntContain',
  LargerThan: 'LargerThan',
  LowerThan: 'LowerThan',
  LowerEqualTo: 'LowerEqualTo',
  LargerEqualTo: 'LargerEqualTo',
});

export const CriterionOperatorSchema = oz.nativeEnum(CRITERION_OPERATORS).openapi('CriterionOperator');

export type CriterionOperator = oz.infer<typeof CriterionOperatorSchema>;